const CLIENT_LOGOUT_FLAG_KEY = 'clientLogoutInProgress'
const CLIENT_LOGOUT_GUARD_MS = 5000

let logoutGuardResetTimer = null
let clientLogoutInProgress = false

export function markClientLogoutInProgress() {
  clientLogoutInProgress = true

  try {
    sessionStorage.setItem(CLIENT_LOGOUT_FLAG_KEY, 'true')
  } catch (error) {
    // Ignore storage access errors in restricted browser contexts.
  }

  if (logoutGuardResetTimer) {
    clearTimeout(logoutGuardResetTimer)
  }

  logoutGuardResetTimer = setTimeout(() => {
    clearClientLogoutInProgress()
  }, CLIENT_LOGOUT_GUARD_MS)
}

export function clearClientLogoutInProgress() {
  clientLogoutInProgress = false

  if (logoutGuardResetTimer) {
    clearTimeout(logoutGuardResetTimer)
    logoutGuardResetTimer = null
  }

  try {
    sessionStorage.removeItem(CLIENT_LOGOUT_FLAG_KEY)
  } catch (error) {
    // Ignore storage access errors in restricted browser contexts.
  }
}

export function isClientLogoutInProgress() {
  if (clientLogoutInProgress) {
    return true
  }

  try {
    return sessionStorage.getItem(CLIENT_LOGOUT_FLAG_KEY) === 'true'
  } catch (error) {
    return false
  }
}

export function notifyLocalAuthStateChanged() {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new Event('storage'))
}
